import React, {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';

import _ from 'lodash';
import { isBlank } from 'utils/object';
import { getFormItemList } from './utils';
import { OptionsContext } from '../DetailLayout/context';
import { Currency, FormMode } from '../../utils';
import { CommonForm } from 'containers/OutBidding/components/CommonForm';
import './index.less';

const InitFormData: Record<string, any> = {
  // currency: Currency.RMB,
  currency: 'rmb',
};

const DemandForm = forwardRef((props: any, ref: any) => {
  const {
    prefixCls = 'bidding-baseinfo-form',
    detail,
    editFields = [],
  } = props;

  const isEdit = !isBlank(detail);

  const [formData, setFormData] = useState(InitFormData);
  const formRef = useRef<any>();
  const optionsMap = useContext(OptionsContext);

  // 初始化数据（detail.id 变化时重新初始化，修复跨单据缓存问题）
  useEffect(() => {
    if (!isBlank(detail)) {
      const {
        l1_category_id,
        l2_category_id,
        product_id,
        bidding_businesses = [],
        budget_currency,
        budget,
        expect_begin_at,
        expect_end_at,
        product_identifier,
        bidding_type_v2,
          ...rest
      } = detail;
      setFormData({
        ...rest,
        l1_category_id,
        l2_category_id,
        product_id,
        bidding_business_ids: bidding_businesses.map((v: any) => v.user_id),
        budget,
        currency: budget_currency,
        expect_begin_at,
        expect_end_at,
        product_name: product_identifier,
        bidding_type_v2
      });
    }
  }, [detail.id]);

  // 对外暴露方法
  useImperativeHandle(ref, () => ({
    validData() {
      if (!(formRef.current && formRef.current.valid())) {
        return false;
      }

      return formData;
    },
  }));

  // 动态渲染 formItem 组件
  const itemList = getFormItemList({
    formData,
    optionsMap,
    setFormData,
    editFields,
  });

  const commonFormProps = {
    formProps: { isLabelVertical: true },
    formItemList: itemList,
  };

  return (
    <div className={prefixCls}>
      {/* Form 组件只有 edit 模式，才会启用非空校验 */}
      <CommonForm
        {...commonFormProps}
        ref={formRef}
        mode={editFields.length ? FormMode.Edit : FormMode.Show}
      />
    </div>
  );
});

export default DemandForm;
